import React from "react";

const STYLES = {
  live: { dot: "bg-[hsl(var(--state-live))] animate-pulse", text: "text-[hsl(var(--state-live))]" },
  wait: { dot: "bg-[hsl(var(--state-wait))]", text: "text-muted-foreground" },
  connecting: { dot: "bg-[hsl(var(--state-connecting))] animate-pulse", text: "text-[hsl(var(--state-connecting))]" },
  error: { dot: "bg-[hsl(var(--state-error))]", text: "text-[hsl(var(--state-error))]" },
};

export const StatusPill = ({ state = "wait", label, testId }) => {
  const s = STYLES[state] || STYLES.wait;
  return (
    <span
      data-testid={testId}
      aria-live="polite"
      className={`inline-flex items-center gap-1.5 rounded-full border border-border/70 bg-secondary/60 px-2.5 py-1 text-xs font-medium ${s.text}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {label}
    </span>
  );
};
